import { render, staticRenderFns } from "./WavePickTasks.vue?vue&type=template&id=9a7ae366&scoped=true&"
import script from "./WavePickTasks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WavePickTasks.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WavePickTasks.vue?vue&type=style&index=0&id=9a7ae366&prod&scoped=true&lang=css&"
import style1 from "./WavePickTasks.vue?vue&type=style&index=1&id=9a7ae366&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7ae366",
  null
  
)

export default component.exports